'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { initAdjust } from '@/lib/adjust';
import { initGa4 } from '@/lib/ga4';
import { initMoengage } from '@/lib/moengage';
const scheduleIdleWork = (work: () => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }
  const idleWindow = window as Window & {
    requestIdleCallback?: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
    cancelIdleCallback?: (handle: number) => void;
  };
  if (idleWindow.requestIdleCallback) {
    const id = idleWindow.requestIdleCallback(work, {
      timeout: 2000
    });
    return () => idleWindow.cancelIdleCallback?.(id);
  }
  const timeoutId = globalThis.setTimeout(work, 1200);
  return () => globalThis.clearTimeout(timeoutId);
};
export function AnalyticsBootstrap() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
}
function _temp2() {
  const boot = _temp;
  let hasBooted = false;
  const runOnce = () => {
    if (hasBooted) {
      return;
    }
    hasBooted = true;
    boot();
    window.removeEventListener("pointerdown", runOnce);
    window.removeEventListener("keydown", runOnce);
    window.removeEventListener("touchstart", runOnce);
  };
  const cancelIdle = scheduleIdleWork(runOnce);
  window.addEventListener("pointerdown", runOnce, {
    once: true,
    passive: true
  });
  window.addEventListener("keydown", runOnce, {
    once: true
  });
  window.addEventListener("touchstart", runOnce, {
    once: true,
    passive: true
  });
  return () => {
    cancelIdle();
    window.removeEventListener("pointerdown", runOnce);
    window.removeEventListener("keydown", runOnce);
    window.removeEventListener("touchstart", runOnce);
  };
}
function _temp() {
  initGa4();
  initAdjust();
  initMoengage();
}